// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app'

// only for develompment

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
// import "firebase/analytics";

// Add the Firebase products that you want to use
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/messaging'

console.log({ env: process.env })

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

// Initialize Firebase
export const firebaseApp = firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth
export const db = firebase.firestore()
export const storage = firebase.storage()
export const messaging = firebase.messaging()

if (window.location.hostname === "localhost") {

  // Note that the Firebase Web SDK must connect to the WebChannel port
  // db.settings({
  //   host: "localhost:8080",
  //   ssl: false,
  // });

  firebase.functions().useFunctionsEmulator('http://localhost:5001');
}

export default firebase
